import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface FeatureSet {
  id?: number;
  rateCompare?: boolean;
  masspay?: boolean;
  defaultNumberOfBanks?: number;
  partnerName?: string;
  panM2p?: boolean;
  tranxFirstStage?: string;
  defaultNumberOfMoneyProviders?: number;
  upi?: boolean;
  amlIntegration?: boolean;
  digioEsign?: boolean;
  rateCompareMaxProviders?: number;
  tranxFirstLetter?: string;
  moneyHopA2Form?: boolean;
  allowedPurposeCodes?: string;
  dualTransaction?: boolean;
  debitCard?: boolean;
  amlUiBlockCrrThreshold?: number;
  panIdfy?: boolean;
  [key: string]: unknown;
}

interface FeatureSetState {
  data: FeatureSet | null;
  loading: boolean;
  error: string;
  fetched: boolean;
}

interface ConfigState {
  featureSet: FeatureSetState;
}

const initialState: ConfigState = {
  featureSet: {
    data: null,
    loading: false,
    error: "",
    fetched: false,
  },
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    fetchFeatureSetRequested(state) {
      state.featureSet.loading = true;
      state.featureSet.error = "";
    },
    fetchFeatureSetSucceeded(state, action: PayloadAction<FeatureSet>) {
      state.featureSet.loading = false;
      state.featureSet.data = action.payload;
      state.featureSet.fetched = true;
      state.featureSet.error = "";
    },
    fetchFeatureSetFailed(state, action: PayloadAction<string>) {
      state.featureSet.loading = false;
      state.featureSet.error = action.payload;
      state.featureSet.fetched = true;
    },
    clearFeatureSet(state) {
      state.featureSet = initialState.featureSet;
    },
  },
});

export const configActions = configSlice.actions;
export default configSlice.reducer;
